<template>
  <div>
    <slot name="label" />
    <div>
      <fwb-input
        :id="id"
        :ref="refName"
        v-model="inputValue"
        :class="[
          'field__input rounded-sm hover:border-etBlue-primary focus:border-etBlue-primary focus:ring-transparent',
          {
            'bg-white': !disabled,
            'border border-rose-500': isRequired,
            'text-center': centered,
            '!rounded-lg': rounded,
            inputPadding: !search,
            iconInput: icon,
            percentageInput: percentage,
            isTypeFile: type === 'file',
            inputAppearanceNone,
            copyModePadding: copyMode
          }
        ]"
        :placeholder="placeholder"
        :disabled="disabled"
        :type="type"
        :autofocus="autofocus"
        :accept="accept"
        :min="min"
        :max="max"
        :step="step"
        :required="isRequired"
        @keypress="validate"
        @blur="$emit('blur')"
      >
        <template #prefix>
          <svg
            v-if="search"
            aria-hidden="true"
            class="w-5 h-5 text-gray-500 dark:text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </template>
        <template #suffix>
          <p v-if="percentage">%</p>
          <i v-if="icon" :class="`${icon} icon`" />
          <font-awesome-icon
            v-if="isRequired"
            icon="fa-solid fa-triangle-exclamation"
            color="red"
          />
          <font-awesome-icon v-if="copyMode" icon="fa-solid fa-clipboard" />
        </template>
      </fwb-input>
    </div>
  </div>
</template>
<script setup>
import { FwbInput } from 'flowbite-vue'
import { onMounted, ref, watch } from 'vue'
const props = defineProps({
  keyName: String,
  type: {
    type: String,
    default: 'text'
  },
  value: String | Number,
  copyMode: {
    type: Boolean,
    default: false
  },
  disabled: Boolean,
  placeholder: String,
  icon: String,
  id: String,
  accept: String,
  refName: String,
  min: Number,
  max: Number,
  step: Number,
  required: {
    type: Boolean,
    default: false
  },
  autofocus: {
    type: Boolean,
    default: false
  },
  rounded: Boolean,
  centered: {
    type: Boolean,
    default: false
  },
  inputAppearanceNone: {
    type: Boolean,
    default: false
  },
  percentage: {
    type: Boolean,
    default: false
  },
  search: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['inputChange'])

const inputValue = ref('')
const isRequired = ref('')

watch(
  () => inputValue.value,
  (val) => {
    if (val === '') {
      isRequired.value = props.required
    } else {
      isRequired.value = false
    }
    if (val === undefined) return
    if (props.type === 'number') {
      if (!val && props.min && props.min > 0) {
        inputValue.value = ''
      }
      if (val && props.max && Number(val) > props.max) {
        inputValue.value = props.max
        return
      }
      if (val && props.min && Number(val) < props.min) {
        inputValue.value = props.min
        return
      }
    }
    emit('inputChange', { value: val, field: props.keyName })
  }
)

watch(
  () => props.value,
  (val) => {
    inputValue.value = val
  }
)

onMounted(() => {
  inputValue.value = props.value
})

function validate(e) {
  if (!e) {
    return
  }
  if (props.type !== 'number') {
    return
  }
  let key
  if (e.type === 'paste') {
    key = e.clipboardData.getData('text/plain')
  } else {
    key = e.keyCode || e.which
    key = String.fromCharCode(key)
  }
  const regex = /[0-9]|\./
  if (!regex.test(key)) {
    e.returnValue = false
    if (e.preventDefault) e.preventDefault()
  }
}
</script>
